/* eslint-disable @microsoft/sdl/react-iframe-missing-sandbox */
import React from 'react';
import { useTranslation } from 'react-i18next';

interface Props {
  videoId: string;
  isActive: boolean;
}

export const VideoSlide = ({ videoId, isActive }: Props) => {
  const { t } = useTranslation(['products']);
  const iframeRef = React.useRef<HTMLIFrameElement | null>(null);

  React.useEffect(() => {
    if (isActive) {
      iframeRef.current?.focus();
    }
  }, [isActive]);

  return (
    <div className="relative flex h-full w-full flex-shrink-0 items-center justify-center overflow-hidden bg-black">
      <iframe
        ref={iframeRef}
        tabIndex={-1}
        title={t('products:product_video')}
        src={`https://player.vimeo.com/video/${videoId}?autoplay=${isActive}&title=0&byline=0&portrait=0`}
        className="absolute inset-0 mb-32 h-full w-full"
        frameBorder="0"
        allow="autoplay; fullscreen"
        allowFullScreen
        sandbox="allow-scripts allow-same-origin allow-presentation"
      />
    </div>
  );
};
